import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
// Service
import { BroadcastService, CONTENT_LOADER_EVENT } from '@cv-invision/core';
import { GenericIntegrationService } from '../service/generic-integration.service';
// Models
import { IntegrationsModel } from '../generic-integrations/models/integrations.model';
import { SetIntegrations } from '../generic-integrations/state/actions/generic-integation.actions';

@Component({
	selector: 'cv-invision-ux-generic-integration-select',
	templateUrl: './generic-integration-select.component.html',
	styleUrls: ['./generic-integration-select.component.scss']
})
export class GenericIntegrationSelectComponent implements OnInit {

	integrations: IntegrationsModel[] = [];
	integration: string = null;

	constructor(
		private router: Router,
		private store: Store,
		private broadcast: BroadcastService,
		private integrationsService: GenericIntegrationService
	) { }

	ngOnInit(): void {
		this.broadcast.broadcast({
			name: CONTENT_LOADER_EVENT,
			event: {
				isLoader: true,
				isSpinnerOn: true,
				hideSubMessage: true,
				message: 'Please wait'
			}
		})
		this.integrationsService.getIntegrations().subscribe((data) => {
			this.integrations = data;
			this.broadcast.broadcast({
				name: CONTENT_LOADER_EVENT,
				event: {
					isLoader: false
				}
			})
		});
	}

	goTo(): void {
		// const integration = this.integrations.find(item => item.integrationId === this.integration);
		this.broadcast.broadcast({
			name: CONTENT_LOADER_EVENT,
			event: {
				isLoader: true,
				isSpinnerOn: true,
				hideSubMessage: true,
				message: 'Please wait'
			}
		});
		this.store.dispatch(new SetIntegrations(this.integrations));

		this.router.navigate([`/global-configuration/generic-integration/${this.integration}/product-types`]);
	}

}
